import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";

export const HeadCommentModalBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 720px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  background: ${Colors.geoWhite100};
  border-radius: 8px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  padding: 32px 40px 40px;
  row-gap: 24px;
  overflow: auto;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 560px;
    padding: 24px 28px 28px;
    row-gap: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    max-width: 100vw;
    max-height: 90vh;
    border-radius: 8px 8px 0 0;
    padding: 24px 16px 24px;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    top: 4px;
    right: 4px;
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo?.hover ?? Colors.galBlack61};
    }
  }
`;

export const HeadCommentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 40px;
`;

export const HeadCommentTitle = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const HeadCommentAuthor = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack61};

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const HeadCommentContent = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  background: ${Colors.galBlack5};
  border-radius: 4px;
  // padding: 16px;
`;

export const HeadCommentTextarea = styled.textarea`
  width: 100%;
  min-height: 180px;
  max-height: 420px;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  cursor: default;

  &:disabled {
    opacity: 1;
    color: ${Colors.galBlack100};
    -webkit-text-fill-color: ${Colors.galBlack100};
  }
`;
import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from "core";

export const HeadCommentModalBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 720px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 64px);
  background: ${Colors.geoWhite100};
  border-radius: 8px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12);
  padding: 32px 40px 40px;
  row-gap: 24px;
  overflow: auto;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    width: 560px;
    padding: 24px 28px 28px;
    row-gap: 16px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    width: 100vw;
    max-width: 100vw;
    max-height: 90vh;
    border-radius: 8px 8px 0 0;
    padding: 24px 16px 24px;
  }
`;

export const CloseModalIconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  cursor: pointer;

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    top: 4px;
    right: 4px;
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.subscribeInfo?.hover ?? Colors.galBlack61};
    }
  }
`;

export const HeadCommentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 40px;
`;

export const HeadCommentTitle = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 23px;
    line-height: 27px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 17px;
    line-height: 22px;
  }
`;

export const HeadCommentAuthor = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack61};

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const HeadCommentContent = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  background: ${Colors.galBlack5};
  border-radius: 4px;
  // padding: 16px;
`;

export const HeadCommentTextarea = styled.textarea`
  width: 100%;
  min-height: 180px;
  max-height: 420px;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  letter-spacing: -0.02em;
  color: ${Colors.galBlack100};
  cursor: default;

  &:disabled {
    opacity: 1;
    color: ${Colors.galBlack100};
    -webkit-text-fill-color: ${Colors.galBlack100};
  }
`;
